import { useState } from "react";
import { Button } from "@/components/ui/button";
import heroItOtUnified from "@/assets/hero-it-ot-unified.png";
import { BetaSignupDialog } from "@/components/beta/BetaSignupDialog";

export function HeroSection() {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <BetaSignupDialog open={dialogOpen} onOpenChange={setDialogOpen} />
      <section className="relative min-h-[85vh] flex flex-col items-center justify-between py-16 bg-gradient-hero text-primary-foreground overflow-hidden">
        {/* Background Image - More visible */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-80 animate-float"
          style={{ backgroundImage: `url(${heroItOtUnified})` }}
        />
        {/* Lighter overlay for better image visibility */}
        <div className="absolute inset-0 bg-gradient-to-t from-primary/50 via-transparent to-primary/50" />

        {/* Top Content - Headlines */}
        <div className="relative z-10 text-center px-4 animate-fade-in">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-2 leading-tight">
            <span className="text-blue-400">Less IT hassle.</span>{" "}
            <span className="text-orange-500">More OT control.</span>
          </h1>
          <p
            className="text-2xl md:text-3xl lg:text-4xl text-white font-semibold animate-fade-in"
            style={{ animationDelay: "0.2s" }}
          >
            One unified view of your entire network
          </p>
        </div>

        {/* Middle - Spacer for image visibility */}
        <div className="flex-1" />

        {/* Bottom Content - Badge and CTA */}
        <div className="relative z-10 text-center px-4">
          {/* Alpha Status Badge */}
          <div className="flex justify-center mb-6 animate-fade-in" style={{ animationDelay: "0.4s" }}>
            <div className="inline-flex flex-col items-center gap-2 px-6 py-3 rounded-full border-2 border-success/60 bg-success/15 backdrop-blur-sm hover:scale-105 transition-transform duration-300">
              <span className="text-sm font-bold text-success uppercase tracking-wider">⚡ Alpha Version</span>
              <span className="text-xs text-white/95">Unified network management • Beta testers wanted</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in"
            style={{ animationDelay: "0.6s" }}
          >
            <Button
              variant="hero"
              size="lg"
              className="text-lg px-8 bg-white text-black hover:bg-gray-300 hover:scale-105 transition-all duration-300"
              onClick={() => setDialogOpen(true)}
            >
              Join Beta Program
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="text-lg px-8 bg-white/10 border-white/40 text-white hover:bg-white/30 hover:scale-105 transition-all duration-300"
            >
              See How It Works
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}
